let menuList = [
  {
    id: 86,
    value: 0,
    backgroundColor: "#ff9c65",
    img: require("@/assets/image/default/work/allocationquery.png"),
    text: "商品档案",
    path: "/Account/sys/itemMasterDefineVue/indexVue.html",
    isHidden: true,
  },
  {
    id: 87,
    value: 0,
    backgroundColor: "#6590ff",
    img: require("@/assets/image/default/work/storeaudit.png"),
    text: "客户档案",
    path: "/Account/sys/customerDefine/indexVue.html",
    isHidden: true,
  },
  {
    id: 6,
    value: 1,
    backgroundColor: "#66d6ff",
    img: require("@/assets/image/default/work/distributiondoc.png"),
    text: "采购进货录单",
    path: "/Account/sys/purchaseInStock/orderEntering.html",
    isHidden: true,
  },
  {
    id: 25,
    idList: [25, 273],
    value: 0,
    backgroundColor: "#7e65ff",
    img: require("@/assets/image/default/work/distributiondocquery.png"),
    text: "销售录单",
    path: "/Account/sys/salConsign/orderEntering.html",
    isHidden: true,
  },
  {
    id: 98,
    value: 0,
    backgroundColor: "#ff67af",
    img: require("@/assets/image/default/work/ordersurplus.png"),
    text: "订单管理",
    path: "/Account/sys/presellProcess/orderManagement.html",
    isHidden: true,
  },
  {
    id: 15,
    value: 0,
    backgroundColor: "#65ebff",
    // img: require("@/assets/image/default/work/salesenquiries.png"),
    img: require("@/assets/image/default/invWare/account.png"),
    text: "库房主账查询",
    path: "/templates/vue-account/dist/index.htm#/inventoryQuery",
    isHidden: true,
  },
  {
    id: 44,
    idList: [44, 251],
    value: 0,
    backgroundColor: "#ffdd65",
    img: require("@/assets/image/default/work/returnaudit.png"),
    text: "门店收款",
    path: "/templates/vue-account/dist/index.htm#/customerArrearPerOrder",
    isHidden: true,
  },
  {
    id: 9,
    idList: [9, 325],
    value: 0,
    backgroundColor: "#ff7567",
    img: require("@/assets/image/default/work/returninquiry.png"),
    text: "调拨查询",
    path: "/Account/sys/billSearchVue/indexVue.html?tag=DBD",
    isHidden: true,
    isView: true,
  },
]

export const getMenuList = (flag) => {
  if (flag) {
    let indexOf44 = menuList.findIndex(i => i.id == 44)
    if (indexOf44 > -1) {
      menuList[indexOf44].id = 251
      menuList[indexOf44].text = '门店收欠款'
      menuList[indexOf44].path = '/yunsierp3/index.html#/payment/collectArrears'
    }
    let indexOf25 = menuList.findIndex(i => i.id == 25)
    if (indexOf25 > -1) {
      menuList[indexOf25].id = 273
      menuList[indexOf25].path = '/yunsierp3/index.html#/enterPage/saleEnter'
    }
    let indexOf6 = menuList.findIndex(i => i.id == 6)
    if (indexOf6 > -1) {
      menuList[indexOf6].text = '采购录单'
    }
    let indexOf15 = menuList.findIndex(i => i.id == 15)
    if (indexOf15 > -1) {
      menuList[indexOf15].text = '主账查询'
    }
    let indexOf9 = menuList.findIndex(i => i.id == 9)
    if (indexOf9 > -1) {
      menuList[indexOf9].text = '调拨录单查看'
    }
    return menuList
  }
  return menuList
}